import $ from "jquery";
import 'slick-carousel';

$(document).ready(function(){
    $('.sections-carousel').slick({
        arrows: true,
        // prevArrow: '<button type="button" class="arrow slide__nav--prew"><svg class="svg"><use xlink:href="/local/templates/delarom/img/sprites/sprite.svg#arrow-left"></use></svg></button>',
        // nextArrow: '<button type="button" class="arrow slide__nav--next"><svg class="svg"><use xlink:href="/local/templates/delarom/img/sprites/sprite.svg#arrow-right"></use></svg></button>',
        slidesToShow: 8,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                slidesToShow: 6,
                slidesToScroll: 3,
                }
            },
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 5,
                centerMode: false,
                }
            },
            {
                breakpoint: 576,
                settings: {
                slidesToShow: 3,
                centerMode: false,
                }
            }
        ]
    });
});